module.exports = __webpack_public_path__ + "img/statuspage.c6f9e514.png";